export const parseQueryId = <T extends number = number>(id: string[] | string | undefined): T => {
  if (id === undefined || Array.isArray(id)) return 0 as T
  const parsed = Number.parseInt(id, 10)
  return (Number.isInteger(parsed) ? parsed : 0) as T
}
